export default __webpack_public_path__ + "static/media/fileUpload.e875c9f7.svg";